var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#E0E5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9176 19.9141C19.7792 19.7764 19.71 19.6124 19.71 19.422C19.71 19.2316 19.7792 19.0696 19.9176 18.9361L21.1635 17.697H15.8623C15.6667 17.697 15.5019 17.6301 15.3678 17.4962C15.2338 17.3623 15.1668 17.1976 15.1668 17.0023C15.1668 16.8069 15.2338 16.6433 15.3678 16.5114C15.5019 16.3795 15.6667 16.3136 15.8623 16.3136H21.1284L19.855 15.0472C19.7283 14.9268 19.6666 14.773 19.6699 14.5858C19.6732 14.3985 19.7453 14.2358 19.8863 14.0975C20.0182 13.9592 20.1832 13.8917 20.3811 13.895C20.5791 13.8982 20.7472 13.9687 20.8857 14.1064L23.3302 16.5376C23.4014 16.6101 23.4538 16.6878 23.4874 16.7708C23.521 16.8537 23.5379 16.9389 23.5379 17.0262C23.5379 17.1135 23.521 17.1976 23.4874 17.2785C23.4538 17.3595 23.4014 17.4359 23.3302 17.508L20.8933 19.9315C20.7666 20.0576 20.6086 20.1206 20.4192 20.1206C20.2299 20.1206 20.0627 20.0518 19.9176 19.9141ZM11.8619 23.5388C11.4786 23.5388 11.1493 23.4029 10.874 23.131C10.5986 22.8591 10.4609 22.5339 10.4609 22.1554V11.8552C10.4609 11.474 10.5986 11.1465 10.874 10.8727C11.1493 10.5988 11.4786 10.4619 11.8619 10.4619H16.3455C16.5411 10.4619 16.7059 10.5308 16.8399 10.6686C16.974 10.8063 17.041 10.9726 17.041 11.1674C17.041 11.3622 16.974 11.5255 16.8399 11.6574C16.7059 11.7893 16.5411 11.8552 16.3455 11.8552H11.8619V22.1554H16.3455C16.5411 22.1554 16.7059 22.2224 16.8399 22.3563C16.974 22.4902 17.041 22.6548 17.041 22.8502C17.041 23.0456 16.974 23.2092 16.8399 23.341C16.7059 23.4729 16.5411 23.5388 16.3455 23.5388H11.8619Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c9046613c587f761e36fee20e7869d45.svg";
export { ForwardRef as ReactComponent };